// extracted by mini-css-extract-plugin
export default {"bottomRow":"BottomRow_bottomRow__nNiQw","labelAndCheckbox":"BottomRow_labelAndCheckbox__63ewe","checkbox":"BottomRow_checkbox__aevPG"};